import {
  InputAdornment,
  TextField as MaterialTextField,
} from "@material-ui/core";
import { styled as materialStyled } from "@material-ui/core/styles";
import { omit } from "lodash";
import React, { useState } from "react";
import styled from "styled-components";
import { colours } from "../../styles/colours";
import { Icon } from "../icons";
import { TextFieldProps } from "./text";

export type PasswordFieldProps = TextFieldProps & {
  obfuscating?: boolean;
};

const CustomMaterialTextField = materialStyled(MaterialTextField)({
  "& .icon-primary": {
    fill: colours.darkGrey,
  },
});

const FieldIcon = styled(Icon)`
  font-size: 1.4em;
`;

const StyledAdornment = styled(InputAdornment)`
  cursor: pointer;
`;

export const Password = React.forwardRef<HTMLInputElement, PasswordFieldProps>(
  (props: PasswordFieldProps, ref) => {
    const [isObfuscated, setObfuscation] = useState(true);

    return (
      <CustomMaterialTextField
        {...omit(props, "obfuscating")}
        ref={ref}
        variant="outlined"
        type={props.obfuscating && !isObfuscated ? "text" : "password"}
        InputProps={{
          endAdornment: props.obfuscating ? (
            <StyledAdornment position="end">
              <FieldIcon
                type={isObfuscated ? "showEye" : "hideEye"}
                onClick={() => setObfuscation(!isObfuscated)}
              />
            </StyledAdornment>
          ) : null,
        }}
      />
    );
  }
);
